import { SxProps, Theme } from '@mui/material';

interface Styles {
  container: SxProps<Theme>;
  paper: SxProps<Theme>;
  header: SxProps<Theme>;
  title: SxProps<Theme>;
  welcomeText: SxProps<Theme>;
  form: SxProps<Theme>;
  error: SxProps<Theme>;
  submitButton: SxProps<Theme>;
}

export const styles: Styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    py: 4,
  },
  paper: {
    p: 4,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: (theme) => theme.palette.background.paper,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    mb: 3,
  },
  title: {
    ml: 1,
    fontWeight: 500,
  },
  welcomeText: {
    mb: 3,
    color: 'text.secondary',
  },
  form: {
    mt: 1,
  },
  error: {
    mt: 2,
  },
  submitButton: {
    mt: 3,
    mb: 2,
    py: 1.5,
  },
};